import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { ErrorMessage, Field, Form, Formik } from 'formik';
import * as Yup from 'yup';
import * as actions from '../../features/schedule/redux/actions';
import * as pluginActions from '../../features/plugin/redux/actions';
import CommonPageComponent from '../../common/ui/CommonPageComponent';
import ParentContentCard from '../common/ParentContentCard';
import CustomInputWithIcon from '../../common/ui/CustomInputWithIcon';
import CustomSelect from '../../common/formElements/CustomSelect';
import { scheduleTypes, taskFrequencies } from '../../common/utils/schedule-utils';
import { pluginCode } from 'drapcode-constant';

export class CreateScheduleTask extends Component {
  static propTypes = {
    schedule: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };

  state = {};

  componentDidMount() {
    const { match, pluginActions } = this.props;
    const { projectId, version } = match.params;
    pluginActions.loadAllInstalledPlugin({ projectId, version });
  }

  taskSchema = () => {
    return {
      name: '',
    };
  };

  taskSchemaValidation = () => {
    let validationSchema = {
      name: Yup.string()
        .required("Task name can't be blank.")
        .max(100, 'Task name can not be more than 100 characters.')
        .matches(/^[A-Za-z0-9\s]+$/, 'Task name should not contain special characters.'),
    };
    return Yup.object().shape(validationSchema);
  };

  handleSubmit = (values) => {
    const { match, schedule, actions, history } = this.props;
    const { projectId, version } = match.params;
    let { name } = values;
    name = name.replace(/\s+/g, ' ');
    values.name = name;
    values.projectId = projectId;
    values.version = version;
    actions.createSchedule(values).then((data) => {
      const { uuid } = data;
      const redirectPath = `/2.0/schedule/${version}/v/${projectId}/update/${uuid}`;
      history.push(redirectPath);
    });
  };

  handleCancel = () => {
    const { match, history } = this.props;
    const { projectId, version } = match.params;
    history.push(`/2.0/schedule/${version}/v/${projectId}/`);
  };

  render() {
    const { schedule, plugin } = this.props;
    const { installedPlugins } = plugin;
    let filteredScheduleTypes = scheduleTypes;
    if (!installedPlugins.some((plugin) => plugin.code === pluginCode.GOOGLE_CALENDAR)) {
      filteredScheduleTypes = scheduleTypes.filter(
        (type) => type.value !== 'SYNC_GOOGLE_CALENDAR_EVENTS',
      );
    }
    const { createSchedulePending } = schedule;
    return (
      <CommonPageComponent>
        <ParentContentCard icon="alarm" title="Create Background Task">
          <Formik
            enableReinitialize={true}
            initialValues={this.taskSchema()}
            validationSchema={this.taskSchemaValidation()}
            onSubmit={(values, { setSubmitting, resetForm }) => {
              this.handleSubmit(values);
              setSubmitting(false);
              resetForm();
            }}
          >
            {({ isSubmitting, values, setFieldValue, setFieldTouched, errors }) => (
              <Form className="form-horizontal">
                <div className="row mx-auto">
                  <div className="col-md-6 col-lg-6 col-sm-6 col-xs-6">
                    <CustomInputWithIcon icon="text" required={true}>
                      <Field
                        type="text"
                        name="name"
                        className="form-control form-control-sm"
                        placeholder="Task Name"
                      />
                      <p className="text-danger">
                        <ErrorMessage name={'name'} />
                      </p>
                    </CustomInputWithIcon>
                  </div>
                  <div className="col-md-6 col-lg-6 col-sm-6 col-xs-6">
                    <CustomInputWithIcon title="Task Type" icon="select" required={false}>
                      <CustomSelect
                        name="taskType"
                        isMulti={false}
                        options={filteredScheduleTypes}
                        onChange={setFieldValue}
                        onBlur={setFieldTouched}
                        placeholder="Task Type"
                        value={values.taskType}
                      />
                    </CustomInputWithIcon>
                  </div>
                  <div className="col-md-6 col-lg-6 col-sm-6 col-xs-6">
                    <CustomInputWithIcon title="Task Frequency" icon="select" required={false}>
                      <CustomSelect
                        name="taskFrequency"
                        isMulti={false}
                        options={taskFrequencies}
                        onChange={setFieldValue}
                        onBlur={setFieldTouched}
                        placeholder="Task Frequency"
                        value={values.taskFrequency}
                      />
                    </CustomInputWithIcon>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-6  ">
                    <button
                      type="button"
                      className="btn btn-outline-secondary btn-md"
                      onClick={this.handleCancel}
                    >
                      <i className="wb webconnect-times"></i> Cancel
                    </button>
                  </div>
                  <div className="col-md-6 text-right">
                    <button
                      type="submit"
                      className="btn btn-theme-submit btn-md"
                      disabled={isSubmitting || createSchedulePending}
                    >
                      Create
                    </button>
                  </div>
                </div>
              </Form>
            )}
          </Formik>
        </ParentContentCard>
      </CommonPageComponent>
    );
  }
}

function mapStateToProps(state) {
  return {
    schedule: state.schedule,
    plugin: state.plugin,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
    pluginActions: bindActionCreators({ ...pluginActions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(CreateScheduleTask);
